import React from "react";
import { ButtonGroup, Dropdown, Form } from "react-bootstrap";
import { Button as BootstrapButton } from "react-bootstrap";
import { DropdownButton as Toggle } from "react-bootstrap";
import Icon, { iconName } from "../icons/Icon";
import "./NutrientDropdown.scss";

export interface DropdownProps {
  children?: React.ReactNode;
  items?: ItemProps[];
}

export interface ItemProps {
  name: string;
  href?: string;
  id: string;
  input?: "radio" | "checkbox" | undefined;
  icon?: iconName;
}

export interface InputProperties {
  active?: string;
  onClick: (id: string) => void;
  children?: React.ReactNode;
  data: Array<[string, string]>;
  input?: "checkbox" | "radio";
}

export interface RadioProperties {
  active?: string;
  onClick: (id: string) => void;
  children?: React.ReactNode;
  id: string;
  name: string;
  input?: "checkbox" | "radio";
}

export interface checkBoxProperties {
  active: boolean;
  onClick: (id: string) => void;
  children?: React.ReactNode;
  id: string;
  name: React.ReactNode;
  input?: "checkbox" | "radio";
  bsPrefix?: string;
}

export interface ButtonProperties {
  children?: React.ReactNode;
  block?: boolean;
  size?: "lg" | "sm" | undefined;
  href?: string;
  variant?: string;
}

const Menu = ({ children }: DropdownProps) => {
  return <Dropdown.Menu className={"nutrient-dropdown"}>{children}</Dropdown.Menu>;
};

const DropdownButton = ({
  title,
  children,
  className,
  variant,
}: {
  title: string;
  children: React.ReactNode;
  className?: string;
  variant?: string;
}) => {
  return (
    <div className={className}>
      <Toggle title={title} variant={variant}>
        <div className={"nutrient-dropdown"}>{children}</div>
      </Toggle>
    </div>
  );
};

const Header = ({ title }: { title: string }) => <Dropdown.Header>{title}</Dropdown.Header>;

const InputGroup = ({ active, onClick, input = "checkbox", data }: InputProperties) => {
  return (
    <>
      {data.map(([id, name]) => (
        <Form.Check
          type={input}
          id={id}
          value={id}
          bsCustomPrefix={active === id ? "custom-control checked" : `custom-control`}
          checked={id === active}
          onClick={() => onClick(id)}
          label={name}
          custom
        />
      ))}
    </>
  );
};

const RadioItem = ({ active, id, input = "radio", onClick, name }: RadioProperties) => {
  return (
    <Form.Check
      type={input}
      id={id}
      value={id}
      bsCustomPrefix={active === id ? `custom-control checked` : `custom-control`}
      checked={id === active}
      onClick={() => onClick(id)}
      label={name}
      custom
    />
  );
};

const CheckboxItem = ({
  active,
  id,
  input = "checkbox",
  onClick,
  name,
  bsPrefix,
}: checkBoxProperties) => {
  return (
    <Form.Check
      type={input}
      id={id}
      value={id}
      bsCustomPrefix={active ? `custom-control checked ${bsPrefix}` : `custom-control ${bsPrefix}`}
      checked={active}
      onChange={() => onClick(id)}
      onClick={() => onClick(id)}
      label={name}
      custom
    />
  );
};

const Item = ({
  children,
  icon,
  href,
}: {
  children: React.ReactNode;
  icon?: iconName;
  href?: string | undefined;
}) => {
  return (
    <Dropdown.Item href={href} id={""}>
      {icon && <Icon icon={icon} size={"fa-lg"} className={"fa-fw"} />}
      {children}
    </Dropdown.Item>
  );
};

const Search = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className={"dropdown-search"}>
      <span>
        <Icon icon={"search"} />
      </span>
      {children}
    </div>
  );
};

const Button = ({ children, size = "lg", block = true, variant, href }: ButtonProperties) => {
  return (
    <div className="dropdown-content">
      <div className={"dropdown-button"}>
        <BootstrapButton variant={variant} block={block} size={size} href={href}>
          {children}
        </BootstrapButton>
      </div>
    </div>
  );
};

const buttonGroup = ({ children }: { children: React.ReactNode }) => (
  <div className={"dropdown-buttongroup"}>
    <ButtonGroup>{children}</ButtonGroup>
  </div>
);

const appItem = ({
  children,
  img,
  href,
  active,
}: {
  children: React.ReactNode;
  img?: string;
  href?: string;
  active?: boolean;
}) => {
  return active ? (
    <Dropdown.Item href={href}>
      {img && <img src={img} width={"24"} height={"24"} alt={""} className="mr-2" />}
      {children}
    </Dropdown.Item>
  ) : (
    <li className={"inactive"}>
      <Dropdown.Item bsPrefix={"dropdown-item"} href={href}>
        {img && <img src={img} width={"24"} height={"24"} alt={""} />}
        {children}
        <div className={"overlay"}>
          <BootstrapButton href={href}>Install app</BootstrapButton>
        </div>
      </Dropdown.Item>
    </li>
  );
};

export default {
  Menu,
  buttonGroup,
  Button,
  Item,
  Header,
  InputGroup,
  Search,
  appItem,
  RadioItem,
  DropdownButton,
  CheckboxItem,
};
